import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { useScenarioData } from "../hooks/useScenarioData";

const ScenarioDataContext = createContext();

export const ScenarioDataProvider = ({ children }) => {
  const scenarioData = useScenarioData();

  return (
    <ScenarioDataContext.Provider value={scenarioData}>
      {children}
    </ScenarioDataContext.Provider>
  );
};

ScenarioDataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useScenarioDataContext = () => {
  const context = useContext(ScenarioDataContext);
  if (!context) {
    throw new Error(
      "useScenarioDataContext must be used within a ScenarioDataProvider",
    );
  }
  return context;
};
